module.exports = __webpack_public_path__ + "img/หอยแมลงภู่.7d36e6de.jpg";